import {Injectable} from '@angular/core';
import {UserService} from '../../lib/user/services/user.service';
import {Configuration} from '../../lib/core/common/configuration';
import {RoutingService} from '../../lib/core/common/routing.service';
import {UtilsService} from '../../lib/core/common/utils/utils.service';
import {StoreService} from '../../lib/core/common/store/store.service';
import {SettingService} from '../../lib/core/common/settings.service';
import {MenuService} from '../../lib/core/menu/menu.service';
import {ToastService} from '../../lib/core/toaster/toast.service';
import {HitFluencerUser} from "../../dto/HitFluencerUser";
import {HitfluencerUserRestService} from "./hitfluencer-user-rest.service";


@Injectable()
export class HitfluencerUserService extends UserService<HitFluencerUser> {

  protected user: HitFluencerUser;
  constructor(protected config: Configuration,
              protected routing: RoutingService,
              protected utils: UtilsService,
              protected store: StoreService,
              protected settings: SettingService,
              protected restService: HitfluencerUserRestService,
              protected menuService: MenuService,
              protected toastService: ToastService) {
    super();
    this.user = new HitFluencerUser();
  }

  setMenuByPermissions(): void {

  }

  updatePreferences(): void {

  }

  protected updateLayout(): void {

  }

  protected addMenu(): void {

  }

  protected newUserInstance(): HitFluencerUser {
    return new HitFluencerUser();
  }

}
